import {ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {FieldRecord} from "../../../model/api/field-record";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CookieService} from "ngx-cookie-service";
import {Trade} from "../../../model/clearing/trade";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {AppConfigService} from "../../../services/app-config.service";
import {CcFormComponent} from "../../../crystal-elements/form-dialog/form/cc-form.component";
import {TradeTableComponent} from "../../clearing/table/trade/trade-table.component";
import {TabView} from "primeng/tabview";
import {AccountType} from "../../../model/exchange/account-type";
import {Trader} from "../../../model/customer/trader";
import {AccountTrader} from "../../../model/customer/account-trader";
import {Owner} from "../../../model/customer/owner";
import {Customer} from "../../../model/customer/customer";
import {ETicket} from "../../../model/eticket/e-ticket";
import {TradingEnvironment} from "../../../model/exchange/trading-environment";
import {Contract} from "../../../model/exchange/contract";
import {ExchangeContractService} from "../../../services/exchange/exchange-contract.service";
import {ThemeService} from "../../../services/tools/theme.service";
import {ETicketLeg} from "../../../model/eticket/e-ticket-leg";
import {EticketService} from "../../../services/eticket/eticket.service";
import {ClearingSelectionSummary} from "../../../model/clearing/clearing-selection-summary";
import TYPE = FormFieldConfig.TYPE;
import OpenClose = AccountDefinition.OpenClose;
import Side = Trade.Side;
import {CcStorageService} from "../../../services/common/cc-storage.service";

@Component({
  selector: 'app-new-e-ticket',
  templateUrl: './new-e-ticket.component.html',
  styleUrls: ['./new-e-ticket.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ]
})
export class NewETicketComponent extends CcBaseComponent {


  tradingEnvironments: FieldRecord<TradingEnvironment>[] = []
  displayedTradingEnvs: FieldRecord<TradingEnvironment>[] = []
  formContracts: Contract[] = []
  contractFields: FieldRecord<any>[] = []
  currentContractsRequest: string[];

  protected formContractsCodes: string[] = [];

  traders: FieldRecord<Trader>[] = [];
  accountTraders: FieldRecord<AccountTrader>[] = [];
  owners: FieldRecord<Owner>[] = [];
  exchanges: FieldRecord<ExchangeDetail>[] = []
  customers: FieldRecord<Customer>[] = [];
  displayedCustomers: FieldRecord<Customer>[] = [];

  originAccounts: FieldRecord<AccountDefinition>[] = [];
  accounts: FieldRecord<AccountDefinition>[] = [];

  accountTypes: FieldRecord<any>[];
  displayedAccountTypes: FieldRecord<any>[];
  displayedGUpAccountTypes: FieldRecord<any>[];

  sides: FieldRecord<any>[] = []
  callPuts: FieldRecord<any>[] = []
  openCloses: FieldRecord<any>[];

  transPartKey: string = 'eticket.new-eticket';

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: ETicket | any;

  loadingProgressValue: number = 0;
  globalErrorMessage: string;

  tableLoading: boolean;

  @ViewChild('tableResult')
  tableResult: TradeTableComponent;

  @ViewChild('ccForm')
  ccForm: CcFormComponent;

  @ViewChild('ccTabView')
  ccTabView: TabView;

  dataToLoadCount: number = 9;

  // currentExchanges: ExchangeDetail[] = [];

  protected summaryBuyValue: ClearingSelectionSummary = {
    apsGrpTotalVolume: 0,
    apsGrpTotalPrice: 0,
    totalVolume: 0,
    totalPrice: 0,
    selectionCount: -1,
    side: Side.BUY
  };

  protected summarySellValue: ClearingSelectionSummary = {
    apsGrpTotalVolume: 0,
    apsGrpTotalPrice: 0,
    totalVolume: 0,
    totalPrice: 0,
    selectionCount: -1,
    side: Side.SELL
  };

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              protected eticketService: EticketService,
              protected exchangeContractService: ExchangeContractService,
              protected commonFieldService: CommonFieldService,
              protected appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              public themeService: ThemeService,
              storageService: CcStorageService) {
    super(cdref, messageService, translateService);
    this.clear();
    // this.formRecord.legs = [new ETicketLeg()];
  }

  ngOnInit() {
    // if (this.storageService.check(this.origin + '_' + CookieNames.ARCHIVE_FORM_FORCEDAY)) {
    //   this.forceDayValue = this.storageService.get(this.origin + '_' + CookieNames.ARCHIVE_FORM_FORCEDAY) === 'true';
    // }
    // if (this.storageService.check(this.origin + '_' + CookieNames.ARCHIVE_FORM_USEPROFILES)) {
    //   this.useProfiles = this.storageService.get(this.origin + '_' + CookieNames.ARCHIVE_FORM_USEPROFILES) === 'true';
    // }
    super.ngOnInit();
  }

  ngAfterContentInit() {
    // setTimeout(() => {
    //   // this.refreshFormConfig(false);
    //   // if (this.ccForm)
    //   //   this.ccForm.reloadFieldValueMap();
    //   // this.detectChanges();
    // });
  }

  protected initConfigs() {
    super.initConfigs();
    this.loadData();
  }

  public loadData() {
    // init data
    this.loadingProgressValue = 0;
    this.sides = [];
    for (let key in Trade.Side) {
      this.sides.push(new FieldRecord(key, key.toLowerCase()))
    }
    this.openCloses = [];
    for (let key in AccountDefinition.OpenClose) {
      this.openCloses.push(new FieldRecord(key, key.toLowerCase()))
    }
    this.callPuts = [];
    for (let key in Trade.CallPut) {
      this.callPuts.push(new FieldRecord(key, key.toLowerCase()))
    }

    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.owners = this.getFields(fieldResult);
      this.refreshFieldData();
    });
    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = this.getFields(fieldResult);
      // this.filterExchanges();
      this.refreshFieldData();
    });
    this.commonFieldService.getCustomers(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.customers = this.getFields(fieldResult);
      this.filterCustomers();
      this.refreshFieldData();
    });
    this.commonFieldService.getAccounts(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.originAccounts = this.getFields(fieldResult);
      this.filterAccountFromCustomers();
      this.refreshFieldData();
    });
    this.commonFieldService.getAccountTypes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.accountTypes = this.getFields(fieldResult);
      this.filterAccountTypes();
      this.refreshFieldData();
    });
    this.commonFieldService.getTraders(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.traders = this.getFields(fieldResult);
      this.refreshFieldData();
    });
    this.commonFieldService.getAccountTraders(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.accountTraders = this.getFields(fieldResult);
      this.refreshFieldData();
    });
    // init data

    this.commonFieldService.getTradingEnvironments(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.tradingEnvironments = this.getFields(fieldResult);
      this.filterTradingEnvs();
      this.refreshFieldData();
    });
    this.refreshFieldData();
    // this.filterContracts();
  }


  public refreshFormConfig() {
    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'orderDescription',
            column: 12,
            type: TYPE.TEXTAREA,
            required: true,
            rightButton: {
              icon: 'fa-solid fa-xmark',
              class: 'clear-btt cc-button-danger',
              tooltip: 'Clear form',
              command: event => {
                this.clear();
              }
            },
          },
          {
            field: 'exchangeCode',
            filter: true,
            column: 3,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.exchanges,
            changed: (event, record) => {
              this.filterCustomers();
              this.filterAccountTypes();
            },
          },
          {
            field: 'contractCode',
            column: 2,
            type: TYPE.TEXT,
          },
          {
            field: 'tradeType',
            column: 2,
            type: TYPE.TEXT,
          },
          {
            field: 'tradingEnvironment',
            filter: true,
            column: 2,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.getDistinctOpts(this.displayedTradingEnvs),
          },
          {
            field: 'desk',
            column: 2,
            type: TYPE.TEXT,
          },
          {
            column: 1,
            type: TYPE.NONE,
          },
          // {
          //   field: 'volume',
          //   column: 2,
          //   type: TYPE.INTEGER,
          //   input: (event, formRecord, inputField) => {
          //     const buyLegs = this.formRecord.legs.filter(leg => leg.side == Side.BUY);
          //     buyLegs.forEach(allocation => {
          //       allocation.volume = 0;
          //     });
          //     if (buyLegs.length > 0) {
          //       buyLegs[0].volume = formRecord.volume;
          //     }
          //     const sellLegs = this.formRecord.legs.filter(leg => leg.side == Side.SELL);
          //     sellLegs.forEach(allocation => {
          //       allocation.volume = 0;
          //     });
          //     if (sellLegs.length > 0) {
          //       sellLegs[0].volume = formRecord.volume;
          //     }
          //     this.crudTable.ccFormDialog.reloadFieldValueMap();
          //   },
          // },
          {
            field: 'maturity',
            column: 2,
            type: TYPE.TEXT,
          },
          {
            field: 'volume',
            column: 1,
            type: TYPE.INTEGER,
            input: (event, formRecord, inputField) => {
              this.formRecord.legs.forEach(leg => {
                leg.volume = 0;
              });
              if (this.formRecord.legs.length > 0) {
                this.formRecord.legs[0].volume = formRecord.volume;
              }
              this.ccForm.reloadFieldValueMap();
            },
          },
          // {
          //   field: 'volumeBuy',
          //   column: 2,
          //   type: TYPE.INTEGER,
          //   input: (event, formRecord, inputField) => {
          //     const buyLegs = this.formRecord.legs.filter(leg => leg.side == Side.BUY);
          //     buyLegs.forEach(allocation => {
          //       allocation.volume = 0;
          //     });
          //     if (buyLegs.length > 0) {
          //       buyLegs[0].volume = formRecord.volumeBuy;
          //     }
          //     this.ccForm.reloadFieldValueMap();
          //   },
          // },
          // {
          //   field: 'volumeSell',
          //   column: 2,
          //   type: TYPE.INTEGER,
          //   input: (event, formRecord, inputField) => {
          //     const sellLegs = this.formRecord.legs.filter(leg => leg.side == Side.SELL);
          //     sellLegs.forEach(allocation => {
          //       allocation.volume = 0;
          //     });
          //     if (sellLegs.length > 0) {
          //       sellLegs[0].volume = formRecord.volumeSell;
          //     }
          //     this.ccForm.reloadFieldValueMap();
          //   },
          // },
          {
            field: 'price',
            column: 2,
            type: TYPE.DECIMAL,
          },
          {
            field: 'callPut',
            column: 1,
            type: TYPE.DROPDOWN,
            options: () => this.callPuts,
            changed: event => {
              this.formRecord.callPut = event.value;
            },
          },
          {
            field: 'strike',
            column: 1,
            type: TYPE.DECIMAL,
          },
          {
            column: 2,
            type: TYPE.NONE,
          },
        ]
      },
      {
        group: '',
        fields: [
          {
            field: 'legs',
            filter: true,
            column: 12,
            type: TYPE.ADDDELETEFIELD,
            validate: record => this.validateLegs(record),
            richFieldConfig: {
              canDelete: formRecords => true,//this.canDeleteSplit(formRecords),
              canAdd: formRecords => true,//this.canAddSplit(formRecords),
              addNew: formRecords => this.addLeg(formRecords),
              class: record => {
                return record.side === Side.BUY ? 'leg-buy' : 'leg-sell';
              },
              fields: [
                {
                  group: '',
                  fields: [
                    {
                      field: 'side',
                      column: 1,
                      type: TYPE.DROPDOWN,
                      options: () => this.sides,
                      changed: (event, record) => {
                        this.refreshTotalVolumes();
                      }
                    },
                    {
                      column: 1,
                      type: TYPE.NONE,
                    },
                    {
                      field: 'maturity',
                      column: 1,
                      type: TYPE.TEXT,
                    },
                    {
                      field: 'volume',
                      column: 1,
                      type: TYPE.INTEGER,
                      input: (event, formRecord, inputField) => {
                        this.refreshTotalVolumes();
                      },
                    },
                    {
                      field: 'price',
                      column: 1,
                      type: TYPE.DECIMAL,
                    },
                    {
                      field: 'customerName',
                      filter: true,
                      column: 2,
                      type: TYPE.AUTOCOMPLETE,
                      options: (record, query) => {
                        const opts: FieldRecord<any>[] = this.getDistinctOpts(this.displayedCustomers)
                        return opts;
                      },
                      changed: (event, event2) => {
                        queueMicrotask(() => this.forceCustomerValues(event2, event.text, event.id));
                      }
                    },
                    {
                      field: 'accountCode',
                      column: 2,
                      type: TYPE.AUTOCOMPLETE,
                      options: (record, query) => {
                        return this.getDistinctOpts(this.filterAccounts(record, query));
                      },
                      changed: (event, record) => {
                        queueMicrotask(() => this.forceAccountValues(record, event.text));
                      }
                    },
                    {
                      field: 'accountTypeCode',
                      filter: true,
                      column: 1,
                      type: TYPE.AUTOCOMPLETE,
                      options: () => this.getDistinctOpts(this.displayedAccountTypes),
                    },
                    {
                      field: 'traderName',
                      filter: true,
                      column: 2,
                      type: TYPE.AUTOCOMPLETE,
                      options: () => this.getDistinctOpts(this.traders),
                    }]
                },
                {
                  group: '',
                  hidden: record => AccountType.GIVE_UP_CODE === record.accountTypeCode,
                  fields: [
                    {
                      column: 1,
                      type: TYPE.NONE,
                      hidden: record => !this.formRecord.orderIds || this.formRecord.orderIds.length == 0,
                    },
                    {
                      column: 2,
                      type: TYPE.NONE,
                    },
                    {
                      field: 'reference1',
                      column: 2,
                      type: TYPE.TEXT,
                      input: (event, formRecord, inputField) => {
                        var start = inputField.selectionStart;
                        var end = inputField.selectionEnd;
                        inputField.value = inputField.value.toUpperCase();
                        formRecord.reference1 = inputField.value;
                        inputField.setSelectionRange(start, end);
                      },
                    },
                    {
                      field: 'reference2',
                      column: 2,
                      type: TYPE.TEXT
                    },
                    {
                      field: 'reference3',
                      column: 2,
                      type: TYPE.TEXT
                    },
                    {
                      field: 'currency',
                      column: 1,
                      type: TYPE.TEXT,
                      input: (event, formRecord, inputField) => {
                        var start = inputField.selectionStart;
                        var end = inputField.selectionEnd;
                        inputField.value = inputField.value.toUpperCase();
                        formRecord.currency = inputField.value;
                        inputField.setSelectionRange(start, end);
                      },
                    },
                  ]
                },
                {
                  group: '',
                  hidden: record => AccountType.GIVE_UP_CODE != record.accountTypeCode,
                  fields: [
                    {
                      column: 2,
                      type: TYPE.NONE,
                    },
                    {
                      field: 'giveUpBrokerCode',
                      column: 2,
                      type: TYPE.TEXT
                    },
                    {
                      field: 'giveUpMessage',
                      column: 2,
                      type: TYPE.TEXT,
                      input: (event, formRecord, inputField) => {
                        var start = inputField.selectionStart;
                        var end = inputField.selectionEnd;
                        inputField.value = inputField.value.toUpperCase();
                        formRecord.giveUpMessage = inputField.value;
                        inputField.setSelectionRange(start, end);
                      },
                    },
                    {
                      field: 'giveUpMessage2',
                      column: 2,
                      type: TYPE.TEXT,
                    },
                    {
                      field: 'broker',
                      column: 2,
                      type: TYPE.TEXT,
                    },
                    {
                      field: 'giveupAccountType',
                      filter: true,
                      column: 1,
                      type: TYPE.AUTOCOMPLETE,
                      options: () => this.getDistinctOpts(this.displayedGUpAccountTypes),
                    },
                    {
                      field: 'currency',
                      column: 1,
                      type: TYPE.TEXT,
                      input: (event, formRecord, inputField) => {
                        var start = inputField.selectionStart;
                        var end = inputField.selectionEnd;
                        inputField.value = inputField.value.toUpperCase();
                        formRecord.currency = inputField.value;
                        inputField.setSelectionRange(start, end);
                      },
                    },
                  ]
                },
              ]
            }
          },
        ]
      },
    ];

    this.validateForm();
    this.reloadFieldValueMap();
  }

  clear() {
    this.formRecord = new ETicket();
    this.formRecord.id = -1;
    this.summaryBuyValue = {
      apsGrpTotalVolume: 0,
      apsGrpTotalPrice: 0,
      totalVolume: 0,
      totalPrice: 0,
      selectionCount: -1,
      side: Side.BUY
    };

    this.summarySellValue = {
      apsGrpTotalVolume: 0,
      apsGrpTotalPrice: 0,
      totalVolume: 0,
      totalPrice: 0,
      selectionCount: -1,
      side: Side.SELL
    };
  }

  save() {
    this.formLoading = true;
    this.eticketService.saveRecord(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.clear()
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  validateForm(): boolean {
    if (!this.formRecord) {
      return false;
    }
    let valid: boolean = true;
    this.formConfig.forEach(grpConfig => {
      grpConfig.fields.forEach(config => {
        if ((!config.hidden || !config.hidden(this.formRecord)) && config.required
          && (!this.formRecord[config.field] || (this.formRecord[config.field] + '').length === 0)) {
          valid = false;
        }
      });
    });
    return valid;
  }

  formRecordChanged(formRecord: any) {
    //store record
    // this.storageService.set(this.origin + '_' + CookieNames.ARCHIVE_FORM_RECORD, JSON.stringify(this.formRecord));
    // console.log("---------------> " + JSON.stringify(this.formRecord))
  }

  public reloadFieldValueMap(): void {
    setTimeout(() => {
      if (this.ccForm)
        this.ccForm.reloadFieldValueMap();
      this.markForCheck();
    });
  }

  public refreshFieldData(): void {
    // let tmpLoadingProgressValue = this.loadingProgressValue;
    // if (tmpLoadingProgressValue != 0)
    this.loadingProgressValue += 100 / this.dataToLoadCount;
    // else
    //   tmpLoadingProgressValue = 100;
    if (this.loadingProgressValue >= 100) {
      this.refreshFormConfig();
    }
    this.ccForm.reloadFieldValueMap();
    this.markForCheck();
    // this.loadingProgressValue = tmpLoadingProgressValue;
  }


  protected filterTradingEnvs() {
    if (this.tradingEnvironments && this.formRecord) {
      this.displayedTradingEnvs = this.tradingEnvironments.filter(field => {
        return !this.formRecord.clearingHouse || this.formRecord.clearingHouse === field.value.clearingHouse;
      });
    } else {
      this.displayedTradingEnvs = [];
    }
  }


  // protected filterExchanges() {
  //   this.currentExchanges.splice(0);
  //   if (this.exchanges && this.formRecord) {
  //     if (this.formRecord.legs && this.formRecord.legs.length > 0) {
  //       this.formRecord.legs.forEach(allocation => {
  //           const exchangeField = this.exchanges ? this.exchanges.find(value => value.id === allocation.exchangeCode) : undefined;
  //           // if (exchangeField && !exchangeField.value.openCloseManagement) allocation.openClose = AccountDefinition.OpenClose.NO;
  //           if (exchangeField && !this.currentExchanges.find(value => value.code === exchangeField.value.code)) {
  //             this.currentExchanges.push(exchangeField.value);
  //           }
  //         }
  //       );
  //     } else {
  //       const exchangeField = this.exchanges ? this.exchanges.find(value => value.id === this.formRecord.exchangeCode) : undefined;
  //       if (exchangeField && !exchangeField.value.openCloseManagement) this.formRecord.openClose = AccountDefinition.OpenClose.NO;
  //       if (exchangeField && !this.currentExchanges.find(value => value.code === exchangeField.value.code)) {
  //         this.currentExchanges.push(exchangeField.value);
  //       }
  //     }
  //   }
  // }

  protected filterCustomers() {
    // if (this.customers && this.formRecord) {
    //   this.displayedCustomers = this.customers.filter(field => {
    //     return !this.formRecord.owner || this.formRecord.owner === field.value.owner;
    //   });
    // } else {
    //   this.displayedCustomers = [];
    // }
    this.displayedCustomers = this.customers;
    this.filterAccountFromCustomers();
  }

  private filterAccountFromCustomers() {
    if (this.originAccounts && this.displayedCustomers && this.originAccounts.length > 0 && this.displayedCustomers.length > 0) {
      // this.accounts.splice(0);
      // this.originAccounts.forEach(field => {
      //   const exchange: ExchangeDetail = this.currentExchanges.find(value => value.clearingHouse === field.value.clearingHouse
      //     && (!field.value.exchangeCode || field.value.exchangeCode === ExchangeDetail.ALL || value.code === field.value.exchangeCode));
      //   const customerField = this.displayedCustomers.find(customer => customer.value.id == field.value.customerId && exchange);
      //   if (customerField && customerField.value.enabled) {
      //     this.accounts.push(field);
      //   }
      // });
      this.accounts = this.originAccounts
    }
  }

  protected filterAccounts(allocationRecord: ETicketLeg, query?: string) {
    let tmpDisplayedAccounts = [];
    if (allocationRecord && this.accounts && this.formRecord) {
      let customerId = undefined;
      if (!query) {
        customerId = allocationRecord.customerId;
        if (!customerId && allocationRecord.customerName && this.customers) {
          const customerField = this.customers.find(customer => customer.text === allocationRecord.customerName);
          if (customerField)
            customerId = customerField.id;
        }
      }
      tmpDisplayedAccounts = this.accounts.filter(field => {
        return (!field.value.exchangeCode
            || field.value.exchangeCode === ExchangeDetail.ALL
            || allocationRecord.exchangeCode === field.value.exchangeCode)
          && (!customerId || '' + field.value.customerId === customerId)
          && (!query || field.value.code.toLowerCase().startsWith(query.toLowerCase()))
      });
    }
    return tmpDisplayedAccounts;
  }

  protected filterAccountTypes() {
    let defaultGUType = FieldRecord.DEFAULT();
    defaultGUType.text = this.translateService.instant('page.account.form.defaultAccountTypeGup');
    defaultGUType.id = AccountType.GIVE_UP_CODE;
    if (this.accountTypes && this.formRecord) {
      this.displayedAccountTypes = this.accountTypes.filter(field =>
        field.id === AccountType.GIVE_UP_CODE || (
          ((!field.value.exchangeCode || field.value.exchangeCode.length === 0
            || field.value.exchangeCode === ExchangeDetail.ALL
            || field.value.exchangeCode === ExchangeDetail.ALL_TEXT
            || this.formRecord.exchangeCode === field.value.exchangeCode))));
      this.displayedGUpAccountTypes = [...this.displayedAccountTypes];
      this.displayedAccountTypes.unshift(defaultGUType);
    } else {
      this.displayedAccountTypes = [defaultGUType];
      this.displayedGUpAccountTypes = [];
    }
  }

  // protected filterContracts() {
  //   if (this.formRecord && this.formRecord.exchangeCode) {
  //     const contractIdParts = [this.exchangeContractService.getContractIdPart(this.formRecord)];
  //     if (!this.currentContractsRequest || JSON.stringify(this.currentContractsRequest) != JSON.stringify(contractIdParts)) {
  //       this.currentContractsRequest = contractIdParts;
  //       this.exchangeContractService.getForIdParts(contractIdParts).subscribe(apiValidation => {
  //           if (apiValidation.success) {
  //             this.formContracts = apiValidation.item;
  //             this.contractFields = apiValidation.item.map(value => new FieldRecord<any>(value.id, value.code));
  //             this.refreshFieldData();
  //           } else {
  //             this.errorMessage(apiValidation.message);
  //           }
  //         }
  //       );
  //     }
  //   } else {
  //     this.formContracts = []
  //     this.contractFields = []
  //     this.refreshFieldData();
  //   }
  // }

  // canDeleteSplit(formRecords: any): boolean {
  //   return this.formRecord.legs.length > 1;
  // }

  // canAddSplit(formRecords: any): boolean {
  //   let totalVol: number = 0;
  //   this.formRecord.legs.forEach(formRecord => {
  //     totalVol += formRecord.volume;
  //   });
  //   return totalVol < this.formRecord.volume;
  // }

  addLeg(formRecords: any) {
    const buyLegs = this.formRecord.legs.filter(leg => leg.side == Side.BUY);
    let totalVolume: number = buyLegs.length == 0 ? this.formRecord.volumeBuy : 0;
    this.formRecord.legs.push({
      id: -1,
      maturity: this.formRecord.maturity,
      volume: totalVolume,
      volumeExecuted: 0,
      apsGroupId: this.formRecord.apsGroupId,
      accountTypeCode: AccountType.GIVE_UP_CODE,
      side: Side.BUY,
      openClose: OpenClose.NO,
      clearingHouse: this.formRecord.clearingHouse,
      exchangeCode: this.formRecord.exchangeCode,
    });

    this.validateLegs(this.formRecord);
  }

  validateLegs(record: any): string {
    let uniqueApsId = undefined;
    let isApsIdUnique = true;

    this.summaryBuyValue.totalVolume = 0;
    this.summarySellValue.totalVolume = 0;
    record.legs.forEach(formRecord => {
      if (formRecord.side === Side.BUY)
        this.summaryBuyValue.totalVolume += formRecord.volume;
      else
        this.summarySellValue.totalVolume += formRecord.volume;
      // if (uniqueApsId && uniqueApsId !== formRecord.apsGroupId) {
      //   this.formRecord.apsGroupId = undefined;
      //   isApsIdUnique = false;
      // }
      // uniqueApsId = formRecord.apsGroupId
    });
    this.summaryBuyValue = {...this.summaryBuyValue};
    this.summarySellValue = {...this.summarySellValue};
    // if (isApsIdUnique) {
    //   this.formRecord.apsGroupId = uniqueApsId;
    // }
    // if (totalVolume != this.formRecord.volume)
    //   return 'page.' + this.transPartKey + '.form.message.volumeDoesNotMatch';

    // this.ccForm.reloadFieldValueMap();
    return '';
  }

  private refreshTotalVolumes() {
    this.formRecord.volumeBuy = 0;
    this.formRecord.volumeSell = 0;
    this.formRecord.legs.forEach(allocation => {
      if (allocation.side == Side.BUY) {
        this.formRecord.volumeBuy += allocation.volume;
      } else {
        this.formRecord.volumeSell += allocation.volume;
      }
    });
    // this.formRecord.volume = Math.max(this.formRecord.volumeBuy, this.formRecord.volumeSell);
    this.formRecord.volume = this.formRecord.volumeBuy + this.formRecord.volumeSell;
    this.ccForm.reloadFieldValueMap();
  }

  protected forceCustomerValues(record, customerName, customerId): void {
    if (customerId) {
      record.customerName = customerName;
      record.customerId = customerId;
    } else {
      record.customerName = undefined;
      record.customerId = undefined;
    }
    record.accountCode = undefined;
    record.accountTypeCode = undefined;
    record.giveupAccountType = AccountType.GIVE_UP_CODE;
    record.executionFee = undefined;
    record.giveUpBrokerCode = undefined;
    record.giveUpCommission = undefined;
    record.giveUpMessage = undefined;
    record.giveUpMessage2 = undefined;
    record.giveUpMessage3 = undefined;
    record.broker = undefined;
    record.openClose = OpenClose.NO;
    record.reference1 = undefined;
    record.reference2 = undefined;
    record.reference3 = undefined;
    record.traderName = undefined;
    this.forceAccountValues(record, '')
    this.ccForm.reloadFieldValueMap();
  }

  protected forceAccountValues(record, accountCode): Customer {
    if (this.accounts.length == 0) {
      this.filterAccountFromCustomers();
    }
    let customer: Customer = undefined;
    const accountField = this.accounts.find(field => (!record.exchangeCode || record.exchangeCode === field.value.exchangeCode
        || (!field.value.exchangeCode && record.clearingHouse == field.value.clearingHouse))
      && field.text?.toLowerCase() === accountCode?.toLowerCase() /*|| field['select']*/);
    if (accountField) {
      const accountDef = {...accountField.value};
      record.accountCode = accountDef.code;
      record.accountTypeCode = accountDef.accountTypeCode;
      record.giveupAccountType = accountDef.giveupAccountType;
      record.executionFee = accountDef.executionFee;
      record.giveUpBrokerCode = accountDef.giveUpBrokerCode;
      record.giveUpCommission = accountDef.giveUpCommission;
      record.giveUpMessage = accountDef.giveUpMessage ? accountDef.giveUpMessage.toUpperCase() : '';
      // if (this.manageGiveUpMssg23(record)) {
      record.giveUpMessage2 = accountDef.giveupMessage2;
      record.giveUpMessage3 = accountDef.giveupMessage3;
      // } else {
      //   record.giveUpMessage2 = undefined;
      //   record.giveUpMessage3 = undefined;
      // }
      record.broker = accountDef.giveupMessage3;
      record.openClose = accountDef.openCloseForFutures;
      record.reference1 = accountDef.reference1 ? accountDef.reference1.toUpperCase() : '';
      record.reference2 = accountDef.reference2;
      record.reference3 = accountDef.reference3;

      const customerField = this.customers.find(customer => customer.id == '' + accountDef.customerId);
      if (customerField) {
        record.customerName = customerField.text;
        accountDef.customerName = customerField.text;
        record.customerId = customerField.id;
        customer = customerField.value;
      }
      record.traderName = this.getTraderNameFromAccountTraders(accountDef);
    } else if (!accountCode || accountCode === '') {
      record.accountCode = undefined;
      record.accountTypeCode = undefined;
      record.giveupAccountType = undefined;
      record.executionFee = undefined;
      record.giveUpBrokerCode = undefined;
      record.giveUpCommission = undefined;
      record.giveUpMessage = undefined;
      record.giveUpMessage2 = undefined;
      record.giveUpMessage3 = undefined;
      record.broker = undefined;
      record.openClose = undefined;
      record.reference1 = undefined;
      record.reference2 = undefined;
      record.reference3 = undefined;
      record.traderName = undefined;
    }
    return customer;
  }

  protected getTraderNameFromAccountTraders(accountDef: AccountDefinition) {
    let traderName = accountDef.traderName;
    if (!traderName) {
      const accountTrader = this.accountTraders.find(aTrader => aTrader.value.accountCode === accountDef.code
        && aTrader.value.owner === accountDef.owner
        && aTrader.value.customerName === accountDef.customerName
        && ((!accountDef.exchangeCode || ExchangeDetail.ALL_TEXT === accountDef.exchangeCode) ||
          (!aTrader.value.exchangeCode || ExchangeDetail.ALL_TEXT === aTrader.value.exchangeCode || aTrader.value.exchangeCode === accountDef.exchangeCode)));

      if (accountTrader) {
        let hasContract = true;
        if (accountTrader.value.contractListInclude) {
          this.formContractsCodes.forEach(contract => {
            if (!accountTrader.value.contractList.split(',').includes(contract)) hasContract = false;
          });
        }
        if (hasContract) {
          const trader = this.accountTraders.find(trader => trader.value.traderCode === accountTrader.value.traderCode)
          if (trader) {
            traderName = trader.text;
          }
        }
      }
    }
    return traderName;
  }

  @HostListener('document:keydown.control.enter', ['$event'])
  submitShortCut(e: KeyboardEvent) {
    if (this.validateForm() && !this.formLoading && this.loadingProgressValue >= 100) {
      this.save();
    }
  }
}
